import React, { useEffect, useState,useCallback } from 'react';
import DemandeSchema from '../components/DemandeSchema';
import { apiFetch } from '../utils/apiClient'; // ✅ import your reusable fetch hel

// import { io } from "socket.io-client";

// const socket = io.connect("${process.env.REACT_APP_API_BASE_URL}"); // Adapter l'URL si nécessaire

function Demande({ user }) {
  const [userId, setuserId] = useState('');
  const [selectedForm, setSelectedForm] = useState('');
  const [selectedEtat, setSelectedEtat] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [numeroFormulaire, setNumeroFormulaire] = useState('');
  const [showFilters, setShowFilters] = useState(true);
  const [sortedData, setSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    if (user) {
      setuserId(user.id);
    }
  }, [user]);

  
    // useEffect(() => {

    //   if (userId) {
    //     // console.log("Connexion WebSocket, envoi de la requête fetchData avec groupes:", userGroups);
    
    //     socket.emit("form", { userId: userId,startDate, endDate,numeroFormulaire});
    
    //     socket.on("MesDemandeData", (data) => {
    //       // console.log("Données reçues du serveur :", data);
    //       setSortedData(data)
    //     });
    
    //     socket.on("error", (err) => {
    //       console.error("Erreur reçue du serveur:", err);
    //     });
    
    //     return () => {
    //       socket.off("MesDemandeData");
    //       socket.off("error");
    //     };
    //   }
    // },);



const fetchData = useCallback(async () => {
  if (!userId) return;

  const queryParams = new URLSearchParams({
    userId,
    ...(startDate ? { startDate } : {}),
    ...(endDate ? { endDate } : {}),
    ...(numeroFormulaire ? { numeroFormulaire } : {})
  });

  try {
    const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/mes-demandes?${queryParams.toString()}`);
    if (!response.ok) {
      throw new Error("Erreur lors de la récupération des données.");
    }
    const data = await response.json();
    setSortedData(data);
    setAuthLoading(false); 
  } catch (error) {
    console.error("Erreur :", error);
  }
}, [userId, startDate, endDate, numeroFormulaire]);

useEffect(() => {
  fetchData();
}, [fetchData]); 

// ✅ plus d'avertissement

    // const fetchData = async () => {
    //   if (!userId) return;
  
    //   const queryParams = new URLSearchParams({
    //     userId,
    //     ...(startDate ? { startDate } : {}),
    //     ...(endDate ? { endDate } : {}),
    //     ...(numeroFormulaire ? { numeroFormulaire } : {})
    //   });
  
    //   try {
    //     const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/mes-demandes?${queryParams.toString()}`);
    //     if (!response.ok) {
    //       throw new Error("Erreur lors de la récupération des données.");
    //     }
    //     const data = await response.json();
    //     setSortedData(data);
    //     console.log(data)
    //   } catch (error) {
    //     console.error("Erreur :", error);
    //   }
    // };
    // useEffect(() => {
      
    //   fetchData();
    // }, [userId, startDate, endDate, numeroFormulaire]); // Ajoute les dépendances nécessaires
    

  // Filtrage des données
  const filteredData = Array.isArray(sortedData)
  ? sortedData.filter(item => {
      const matchesForm = selectedForm ? item.formulaire === selectedForm : true;
      const matchesEtat = selectedEtat ? item.etatDemande === selectedEtat : true;
      return matchesForm && matchesEtat;
    })
  : [];
  const handleDropdownChange = (event) => {
    setSelectedForm(event.target.value);
    setCurrentPage(1)
  };

  const handleEtatChange = (event) => {
    setSelectedEtat(event.target.value);
    setCurrentPage(1)
  };

  const handleClearFilters = () => {
    setSelectedForm('');
    setSelectedEtat('');
    setNumeroFormulaire('');
    setStartDate('');
    setEndDate('');
    setCurrentPage(1)
  };

  return (
    <div className="min-h-screen p-4">
      <button
        onClick={() => setShowFilters(!showFilters)}
        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold mb-4 px-2 py-2 rounded-xl shadow-md transition-all duration-200"

      >
        {showFilters ? 'Masquer les filtres' : 'Afficher les filtres'}
      </button>

      {showFilters && (
  <div className="flex flex-wrap gap-4 mb-6 bg-white p-6 rounded-2xl shadow-lg border border-gray-200 transition-all duration-300">
    
    {/* Filtre Formulaire */}
    <div className="flex flex-col">
      <label htmlFor="formFilter" className="mb-1 text-md font-semibold text-gray-700">Formulaire</label>
      <select
        id="formFilter"
        value={selectedForm}
        onChange={handleDropdownChange}
        className="p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
      >
        <option value="">Tous les formulaires</option>
        <option value="Accès hors pays">Accès hors pays</option>
        <option value="Accès au compte informatique">Accès au compte informatique</option>
        <option value="Achat équipement informatique">Achat équipement informatique</option>
        <option value="Antécédents criminels">Antécédents criminels</option>
        <option value="Changement adresse">Changement d'adresse</option>
        <option value="Changement nom">Changement nom</option>
        <option value="Changement information bancaire">Changement information bancaire</option>
        <option value="Demande AEFO">Demande AEFO</option>
        <option value="Demande FEESO">Demande FEESO</option>
        <option value="Demande SCFP">Demande SCFP</option>
        <option value="Demande de projet">Demande de projet</option>
        <option value="Réclamation mensuelle de dépenses">Réclamation mensuelle de dépenses</option>
      </select>
    </div>

    {/* Filtre Statut */}
    <div className="flex flex-col">
      <label htmlFor="etatFilter" className="mb-1 text-md font-semibold text-gray-700">Statut</label>
      <select
        id="etatFilter"
        value={selectedEtat}
        onChange={handleEtatChange}
        className="p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
      >
        <option value="">Tous</option>
        <option value="Brouillon">Brouillon</option>
        <option value="Supprimé">Supprimé</option>
        <option value="En attente">En attente</option>
        <option value="En traitement">En traitement</option>
        <option value="Approuvé">Approuvé</option>
        <option value="Rejeté">Rejeté</option>
        <option value="Soumis">Soumis</option>
      </select>
    </div>

    {/* Filtre Numéro */}
    <div className="flex flex-col">
      <label htmlFor="numeroFormulaire" className="mb-1 text-md font-semibold text-gray-700">Numéro du Formulaire</label>
      <input
        type="text"
        id="numeroFormulaire"
        value={numeroFormulaire}
        onChange={(e) => {
          setNumeroFormulaire(e.target.value);
          setCurrentPage(1);
        }}
        placeholder="Entrez le numéro"
        className="p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
      />
    </div>

    {/* Filtre Date de début */}
    <div className="flex flex-col">
      <label htmlFor="startDate" className="mb-1 text-md font-semibold text-gray-700">De</label>
      <input
        type="date"
        id="startDate"
        value={startDate}
        onChange={(e) => { setStartDate(e.target.value); setCurrentPage(1); }}
        className="p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
      />
    </div>

    {/* Filtre Date de fin */}
    <div className="flex flex-col">
      <label htmlFor="endDate" className="mb-1 text-md font-semibold text-gray-700">À</label>
      <input
        type="date"
        id="endDate"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        className="p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
      />
    </div>

    {/* Bouton Réinitialiser */}
    <div className="flex items-end">
      <button
        onClick={
          handleClearFilters}
        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold   px-2 py-3 rounded-xl shadow-md transition-all duration-200"
      >
        Réinitialiser
      </button>
    </div>

  </div>
)}


      {/* {filteredData.length > 0 ? ( */}
        <DemandeSchema 
          formData={filteredData}   
          currentPage ={currentPage} 
          setCurrentPage ={setCurrentPage} 
          fetchData={fetchData}
          user={user}
          authLoading={authLoading}
        />
      {/* // ) : (
      //   <p className="text-center mt-4 text-gray-500">Aucune demande trouvée.</p>
      // )} */}
    </div>
  );
}

export default Demande;
// fetchFormData={fetchFormData}